import lazyLoadView from "@router/lazyload-view";
import routeError from "@router/route-error";
import store from '@store'

export default [
  // 影片專區 列表頁
  {
    path: '/video',
    name: 'video-list',
    component: () => lazyLoadView(import('@views/Video/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const { brand, query, month, page = 1 } = routeTo.query
          const params = {
            search: query || undefined,
            brand_alias: brand
              ? [brand]
              : undefined,
            search_date: month || undefined,
            limit: 9,
            page,
          }
          const [{ items, featured, pagination }, brandOptions] = await Promise.all([
            store.dispatch('article/fetchList', {
              contentAlias: 'video',
              params
            }),
            store.dispatch("category/fetchCategroy",{
              types: ['brand'],
              pageAlias: 'video'
            })
          ])
          routeTo.params.list = items
          routeTo.params.topList = featured
          routeTo.params.pagination = pagination
          routeTo.params.brandOptions = brandOptions.brand

          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "video",
      title: '影片專區列表',
    },
    props: (route) => ({
      list: route.params.list,
      topList: route.params.topList,
      pagination: route.params.pagination,
      brandOptions: route.params.brandOptions,
    })
  },
  // 解決方案 內容頁
  {
    path: '/video/:videoAlias',
    name: 'video-item',
    component: () => import('@views/Brand/Video/Item'),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const currentItem = await store.dispatch('article/fetchItem', {
            contentType: 'video',
            alias: routeTo.params.videoAlias,
          })
          const [currentBrand] = await Promise.all([
            store.dispatch('brand/fetchBrand', {
              brandAlias: currentItem.items.brands[0].alias
            }),
          ])
          routeTo.params.currentBrand = currentBrand;
          routeTo.params.defaultValue = currentItem.items;
          // routeTo.params.breadcrumbTitle = currentItem.title;
          routeTo.params.breadcrumbLevel3Title = store.state.brand.cachedBrand.title;

          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "video",
      title: '影片專區',
    },
    props: (route) => ({
      defaultValue: route.params.defaultValue,
      // currentBrand : route.params.currentBrand || {},
    })
  },
]
